import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NewPermission } from '@core/enums/permission';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TsButtonModule, TSIconModule } from 'tsui';
import { TsComponent } from '../../ts.component';
import { EngagementsModule } from 'app/modules/engagements/enagements.module';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Engagement, EngagementType } from 'app/modules/engagements/engagements.types';
import { AddEngagementDialogComponent } from 'app/modules/engagements/modals/add-engagement/add-engagement.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { JupiterState } from 'app/modules/jupiter/@store/state';
import { combineLatest, forkJoin, noop, Observable, switchMap, take, tap } from 'rxjs';
import { Entity } from 'app/modules/jupiter/types';
import { Contact } from 'app/modules/contacts/contacts.types';
import { EntityActions } from 'app/modules/jupiter/@store/actions';

@Component({
  selector: 'app-engagements',
  standalone: true,
  imports: [TsButtonModule, DirectivesModule, TSIconModule, EngagementsModule, NgTemplateOutlet, AsyncPipe],
  templateUrl: './engagements.component.html',
  styleUrl: './engagements.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JupiterEngagementTabComponent extends TsComponent implements OnInit {
  NewPermission = NewPermission;

  entity$: Observable<Entity> = this.store.select(JupiterState.getEntity).pipe(
    takeUntilDestroyed(this.destroyRef),
    tap((entity) => {
      if (entity) {
        this.store.dispatch(new EntityActions.EngagementActions.Load());
      }
    }),
  );

  engagements$: Observable<Engagement[]> = this.store.select(JupiterState.getEngagementsItems);
  contacts$: Observable<Contact[]> = this.store.select(JupiterState.getEngagementsContacts);

  ngOnInit(): void {}

  openEngagementModal(type: EngagementType): void {
    combineLatest([this.accountService.getStandardDropdowns(), this.contacts$]) // this is not good, but I'm keeping the same behavior as before
      .pipe(
        take(1),
        switchMap(([options, contacts]) => {
          return this.matDialog
            .open(AddEngagementDialogComponent, {
              data: {
                [this.store.selectSnapshot(JupiterState.getRelatedTo).toLowerCase()]: this.store.selectSnapshot(
                  JupiterState.getEntity,
                ),
                options,
                engagement_type: type,
                contacts,
              },
            })
            .afterClosed();
        }),
        tap((result) => {
          if (result) {
            this.store.dispatch(new EntityActions.EngagementActions.Load('onlyEngagements'));
          }
        }),
      )
      .subscribe(noop);
  }
}
